import { useCallback } from "react";

import { useAppDispatch } from "Store/hooks";

import { getUserAccessByUserIdThunk } from "../thunks/getUserAccessByUserId.thunk";

export const useGetUserAccessByUserId = () => {
  const dispatch = useAppDispatch();

  return useCallback(
    (projectId: string, userId: string) => {
      if (projectId && userId)
        return dispatch(getUserAccessByUserIdThunk({ projectId, userId }));
    },
    [dispatch]
  );
};
